import "./TmcListComponent.scss";
import template from "./TmcListComponent.html";
import {IComponentOptions} from "angular";
import { IModalInstanceService } from "angular-ui-bootstrap";
import {TmcDefinition, TmcDefinitions} from "../../models/TmcDefinition";
import {Observable, ReplaySubject} from "rxjs";
import {TmcListModel, TmcListModels} from "./internal/TmcListModel";
import {OptionContractsCache} from "../../../options/contracts/cache/OptionContractsCache";
import {BuildModels} from "./util/TmcListComponentUtil";
import {OptionRecords} from "../../../options/contracts/models/OptionChainRecord";

export const TmcList = "tfTmcListComponent";

export function tmcList(): IComponentOptions {
    return {
        template,
        bindings: {
            modalInstance: "<",
            resolve: "<"
        },
        controllerAs: "ctrl",
        controller: TmcListComponentController
    };
}

interface Resolve {
    readonly tmcs: TmcDefinitions;
    readonly options: OptionRecords;
}

export class TmcListComponentController {

    /** @input */
    public readonly modalInstance: IModalInstanceService;

    /** @input */
    public set resolve(resolve: Resolve) {
        if ((resolve != null) && (resolve.tmcs != null) && (resolve.options != null)) {
            this.models = BuildModels(resolve.tmcs, resolve.options);
        }
    }

    public selected: TmcListModel | null;

    public models: TmcListModels;

    public confirm() {
        if (this.selected != null) {
            this.modalInstance.close(this.selected.tmc);
        }
    }

    public cancel() {
        this.modalInstance.dismiss();
    }
}
